import { lazy } from 'react';

// ----------------------------------------------------------------------

const LoginPage = lazy(() => import('../pages/Login.page'));
const NewPasswordPage = lazy(() => import('../pages/NewPassword.page'));
const ForgotPasswordPage = lazy(() => import('../pages/ForgotPassword.page'));
const ResetPasswordPage = lazy(() => import('../pages/ResetPassword.page'));
// ----------------------------------------------------------------------

const LoginRoutes = [
    {
        path: '/login',
        element: <LoginPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/new-password',
        element: <NewPasswordPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/forgot-password',
        element: <ForgotPasswordPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reset-password',
        element: <ResetPasswordPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { LoginRoutes };
